export default "__VITE_ASSET__BbiBkKZR__"